const loadedScripts = new Map();

// Loads an external SDK <script> tag once and resolves when it's ready. `globalCheck`
// is the property this script attaches to `window` (e.g. "Razorpay", "Stripe") — if
// it's already present, the script is treated as loaded and no new tag is injected.
const loadScript = (src, globalCheck) => {
  if (globalCheck && window[globalCheck]) return Promise.resolve(window[globalCheck]);
  if (loadedScripts.has(src)) return loadedScripts.get(src);

  const promise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve(globalCheck ? window[globalCheck] : true);
    script.onerror = () => {
      loadedScripts.delete(src);
      reject(new Error(`Failed to load script: ${src}`));
    };
    document.body.appendChild(script);
  });

  loadedScripts.set(src, promise);
  return promise;
};

export default loadScript;
